/*
 * @Author: xulihuan
 * @Date:   2018-04-14 12:19:04
 * @Last Modified by:   联想
 * @Last Modified time: 2018-04-14 12:21:30
 */

;(function(win) {
  /**
   *
   * @param str
   * @param time
   */
  function toast(str, time = 1000) {
    let $root = document.body
    let $toast = $root.querySelector('.yxl-toast')

    if ($toast) {
      remove($toast.getAttribute('data-id'))
    }

    $toast = document.createElement('div')

    $toast.classList.add('yxl-toast')
    $toast.innerHTML = str

    let timeId = setTimeout(() => {
      remove()
    }, time)
    $toast.setAttribute('data-id', timeId)

    $root.appendChild($toast)

    function remove(id) {
      if ($toast) {
        try {
          $root.removeChild($toast)
          if (id) {
            clearTimeout(id)
          }
          $toast = null
        } catch (e) {
          console.error(e)
        }
      }
    }
  }

  win.toast = toast
})(window)



// WEBPACK FOOTER //
// ./src/libs/toast.js